import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DETAIL_ICON_PATHS } from './detail-icon.constant';

const DEFAULT_ICON_SIZE = 16;

/**
 * Renders one of the inline line icons used across the detail screens.
 *
 * The icon inherits `currentColor`, so colour is controlled by the surrounding
 * text style; `size` sets both width and height in pixels.
 */
@Component({
  selector: 'app-detail-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="size"
      [attr.height]="size"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false">
      <path *ngFor="let path of paths" [attr.d]="path"></path>
    </svg>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
      }
    `,
  ],
})
export class DetailIconComponent {
  @Input({ required: true }) set name(value: string) {
    this.paths = DETAIL_ICON_PATHS[value] ?? [];
  }
  @Input() size = DEFAULT_ICON_SIZE;

  paths: string[] = [];
}
